/**
 * @generated SignedSource<<55d14068d12128d6c18ce50d3b2aedf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentCategorySection_AtlassianConversationAssistantAgent_AgentCategorySectionContent$data = {
  readonly agentStudio_getAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly authoringTeam: {
          readonly displayName: string | null;
          readonly id: string;
          readonly profileUrl: string | null;
          readonly smallAvatarImageUrl: string | null;
        } | null;
        readonly conversationStarters: ReadonlyArray<string> | null;
        readonly creator: {
          readonly id: string;
        } | null;
        readonly creatorType: string | null;
        readonly deactivated: boolean | null;
        readonly description: string | null;
        readonly externalConfigReference: string | null;
        readonly forgeCreator: string | null;
        readonly icon: string | null;
        readonly id: string;
        readonly identityAccountId: string | null;
        readonly isFavourite: boolean | null;
        readonly name: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianConversationAssistantAgent_agentRef" | "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef" | "agentVerified_AtlaskitRovoAgentComponents">;
      } | null;
    }>;
  } | null;
  readonly " $fragmentType": "agentCategorySection_AtlassianConversationAssistantAgent_AgentCategorySectionContent";
};
export type agentCategorySection_AtlassianConversationAssistantAgent_AgentCategorySectionContent$key = {
  readonly " $data"?: agentCategorySection_AtlassianConversationAssistantAgent_AgentCategorySectionContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"agentCategorySection_AtlassianConversationAssistantAgent_AgentCategorySectionContent">;
};

import agentCategorySectionPaginationQuery_graphql from './agentCategorySectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "agentStudio_getAgents"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudIdAsId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "enableJiraAgentFields"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "product"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": agentCategorySectionPaginationQuery_graphql
    }
  },
  "name": "agentCategorySection_AtlassianConversationAssistantAgent_AgentCategorySectionContent",
  "selections": [
    {
      "alias": "agentStudio_getAgents",
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        },
        {
          "kind": "Variable",
          "name": "product",
          "variableName": "product"
        },
        {
          "kind": "Variable",
          "name": "workspaceId",
          "variableName": "workspaceId"
        }
      ],
      "concreteType": "AgentStudioAgentsConnection",
      "kind": "LinkedField",
      "name": "__paginatedAgentsList_agentStudio_getAgents_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "AgentStudioAgentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "AgentStudioAssistant",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "name"
                },
                {
                  "kind": "ScalarField",
                  "name": "deactivated"
                },
                {
                  "kind": "ScalarField",
                  "name": "description"
                },
                {
                  "kind": "ScalarField",
                  "name": "isFavourite"
                },
                {
                  "kind": "ScalarField",
                  "name": "creatorType"
                },
                {
                  "kind": "ScalarField",
                  "name": "conversationStarters"
                },
                {
                  "kind": "ScalarField",
                  "name": "identityAccountId"
                },
                {
                  "kind": "ScalarField",
                  "name": "externalConfigReference"
                },
                {
                  "kind": "LinkedField",
                  "name": "creator",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "icon"
                },
                {
                  "concreteType": "TeamV2",
                  "kind": "LinkedField",
                  "name": "authoringTeam",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "profileUrl"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "smallAvatarImageUrl"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "forgeCreator"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "agentVerified_AtlaskitRovoAgentComponents"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef"
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "cloudId",
                      "variableName": "cloudIdAsId"
                    },
                    {
                      "kind": "Variable",
                      "name": "enableJiraAgentFields",
                      "variableName": "enableJiraAgentFields"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "agentCard_AtlassianConversationAssistantAgent_agentRef"
                },
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "7298d1e5134ddeb63fc9cdecad5ec3ac";

export default node;
